/** The server-assigned filename from Content-Disposition; the RFC 5987 `filename*=UTF-8''` form wins because it carries Mongolian titles intact (plain `filename=` is an ASCII fallback). */
export function filenameFrom(header: unknown): string | null {
  if (typeof header !== 'string') return null
  const star = /filename\*=UTF-8''([^;]+)/i.exec(header)
  if (star) {
    try {
      return decodeURIComponent(star[1].trim())
    } catch {
      // fall through to the plain parameter
    }
  }
  const plain = /filename=(?:"([^"]*)"|([^;]+))/i.exec(header)
  return plain ? (plain[1] ?? plain[2]).trim() : null
}
